<template>
  <Article :title="title" :subtitle="subtitle" :header="true">
    <section class="kc-elm kc-css-911125 kc_row">
      <div class="befbgr" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="befbgr" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="aftbgr" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="aftbgr" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="befbgr5" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="befbgr6" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="aftbgr7" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="aftbgr8" data-ssc-svg data-ssc-img-s="full" data-ssc-img-anim="none"></div>
      <div class="kc-row-container kc-container">
        <div class="kc-wrap-columns">
          <div class="kc-elm kc-css-225715 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
              <div class="ssc_mltttl kc-elm kc-css-512028">
                <h2 class="wr deb derb dea dera none nonea">
                  <span class="t1">4</span>
                  <span class="t2">0</span>
                  <span class="t1">4</span>
                </h2>
              </div>
              <div class="kc-elm kc-css-63077 kc_text_block">
                <p>The requested URL was not found on this server..</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Article>
</template>

<script>
import Article from "@/components/layout/Article";

export default {
  name: "PageNotFound",
  components: {
    Article
  },
  data() {
    return {
      title: "Page Not Found",
      subtitle: "404 Error"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ssc-subtitle {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/PageNotFound.vue